import axios, { LONG_TIMEOUT_MS } from "utils/axios";

export const getConversations = (params, config = {}) => {
  return axios.get("/WA/conversations", { params, ...config });
};

export const getConversationsSearch = (params) => {
  return axios.get("/WA/conversations/search", { params });
};

export const sendMessages = (data) => {
  return axios.post("/WA/conversations/messages", data);
};

export const updateContact = ({ id, ...data }) => {
  return axios.patch(`/WA/contacts/${id}`, data);
};

export const uploadMedia = (data) => {
  return axios.post("/WA/medias", data, { timeout: LONG_TIMEOUT_MS });
};

export const getConversationsMessages = (lastMessageId) => {
  return axios.get("/WA/conversations/messages", {
    params: { last_id: lastMessageId },
  });
};

export const getConversationsMessagesStatusLogs = (params) => {
  return axios.get("/WA/conversations/messages/statusLogs", { params });
};

export const closeConversation = (id, payload) => {
  return axios.post(`/WA/conversations/${id}/close`, payload);
};

export const typingConversation = (id) => {
  return axios.patch(`/WA/conversations/${id}/typing`);
};

export const getContactSuggestionPerPage = (params) => {
  return axios.get("/WA/contacts/suggestionPerPage", { params });
};

export const getConversation = (id, payload, config = {}) => {
  return axios.get(`/WA/conversations/${id}`, { params: payload, ...config });
};

export const postOnline = (isOnline) => {
  return axios.post("/WA/onlines", { is_online: isOnline });
};

export const updateConversation = (id, payload) => {
  return axios.put(`/WA/conversations/${id}/notes-category`, payload);
};

export const takeConversation = (payload) => {
  return axios.post(
    `/WA/conversations/${payload.conversation_id}/take`,
    payload
  );
};

export const transferConversation = (payload) => {
  return axios.post(
    `/WA/conversations/${payload.conversation_id}/assign`,
    payload
  );
};

export const downloadMessageMedia = (messageId) => {
  return axios.get(`/WA/medias/download/messages/${messageId}`, {
    responseType: "blob",
    timeout: LONG_TIMEOUT_MS,
  });
};

export const autoTransferWaitingClient = (conversationId) => {
  return axios.post(
    `/WA/conversations/${conversationId}/autoTransferWaitingClient`,
    { conversation_id: conversationId }
  );
};
